import { Heading } from '@/modules/ui/components/heading/Heading';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode | null;
  action?: React.ReactNode;
}

export const PageHeader = ({ title, subtitle, action }: PageHeaderProps) => {
  return (
    <div className="flex items-center justify-between pb-8">
      <div className="flex flex-col gap-1">
        <Heading variant="h3">{title}</Heading>
        {subtitle && <Paragraph variant="body">{subtitle}</Paragraph>}
      </div>
      {action}
    </div>
  );
};
